export default __webpack_public_path__ + "static/media/andrea-home.6e8bceda.webp";